import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lightning",
  "use": "icon-lightning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lightning\"><defs><style type=\"text/css\"></style></defs><path d=\"M819.2 0H307.2L204.8 512h93.184L204.8 1024 716.8 460.8h-128L819.2 0z\" p-id=\"2145\" fill=\"#2c2c2c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol